import { getClientSecretTargetUrl, whichUrlShouldBePassed } from '@/utils/utils';

export const goToSosOvm = (appendPoaToCTA, clientSecretUrl, answeredSlides) => {
  const url = new URL(clientSecretUrl || getClientSecretTargetUrl(whichUrlShouldBePassed(location.href)));
  const search =
    appendPoaToCTA && answeredSlides.legal_insurance === 'Ja' ? url.search.concat('&poa=insurance') : url.search;
  window.location.href = `${url.origin}/${search}${url.hash}`;
};
